import Vue from "vue";
import store from "./store";
import MyStudyChoiceOnboardingWidget from "./MyStudyChoiceOnboardingWidget.vue";

import {getAttributeValue} from "@/shared/filters/utils-filter";
import VueCompositionAPI from "@vue/composition-api";

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI)
let element = document.querySelectorAll('my-studychoice-onboarding');

if (element.length) {
    element.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h) {
                return h(MyStudyChoiceOnboardingWidget, {
                    props: {
                        eventListener: getAttributeValue(el, 'event-listener'),
                        initialize: getAttributeValue(el, 'initialize') === "true",
                        labels: getAttributeValue(el, 'labels', true),
                        flow: getAttributeValue(el, 'flow')
                    }
                })
            }
        })
    })
}
